import { type MapBounds } from '@/packages/redux-state/store/slices/mapConfiguration/slice';

import { type IBBoxSchema } from '@/repositories/generated/shared/search-offers-index/entities/bbox/BBoxSchema';
import { type TMapGetBboxResponse_1 } from '@/repositories/generated/shared/search-offers-index/v2/map/get-bbox';

export function mapPreparedMapBboxSelector({ bbox }: TMapGetBboxResponse_1): MapBounds {
  const {
    topLeft: { lat: latMax, lng: lngMin },
    bottomRight: { lat: latMin, lng: lngMax },
  } = bbox as IBBoxSchema;

  return [
    [latMax, lngMin],
    [latMin, lngMax],
  ];
}
